export default "__VITE_ASSET__578b82e2__"